import Create from './Create';
import Update from './Update';
import Delete from './Delete';
import Search from './Search';
import Body   from './Body'  ;

type Props = {
  Update: typeof Update;
  Create: typeof Create;
  Delete: typeof Delete;
  Search: typeof Search;
  Body  : typeof Body  ;
}

const ProvinceComponents: Props = {
  Delete,
  Update,
  Create,
  Search,
  Body  ,
}

export default ProvinceComponents;
